import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TextoTermosService } from '../../operacao/termos-e-condicoes/texto-termos-contratacao-tag.service';

@Component({
    templateUrl: './termos-envio-devolucao-honra-modal.component.html',
    standalone: false
})
export class TermosEnvioDevolucaoHonraModalComponent implements OnInit {

    public callback: any;
    public termos: string;

    cienciaDosTermosConfirmada = false;

    constructor(private _activeModal: NgbActiveModal,
        private termosService: TextoTermosService) {
    }

    ngOnInit(): void {
        this.termosService.termosEnvioDevolucaoHonra$.subscribe((resp) => {
            this.termos = resp;
        });
    }

    public cancelar() {
        this._activeModal.dismiss({});
    }

    public ok() {
        this._activeModal.dismiss({});
        this.callback(this.cienciaDosTermosConfirmada);
    }

    changeCheck(event) {
        this.cienciaDosTermosConfirmada = event.target.checked;
    }
}